import { render, staticRenderFns } from "./AcompanhamentoItemPassosParalelos.vue?vue&type=template&id=728b8410"
import script from "./AcompanhamentoItemPassosParalelos.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoItemPassosParalelos.vue?vue&type=script&lang=js"
import style0 from "./AcompanhamentoItemPassosParalelos.vue?vue&type=style&index=0&id=728b8410&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports